export const localNow = () => {
  const now = new Date();
  return new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};
export const initialLifecycleForm = (lineId = "", responsible = "") => ({
  eventType: "CONTACT", responsibleUserKey: String(responsible), occurredAt: localNow(), content: "",
  contactTarget: "", contactChannel: "전화", orderLineId: String(lineId || ""),
  nextCheckDate: "", changeRequestId: "", resumeStatus: "", quantity: "", requestedDueDate: "",
  itemCode: "", itemName: "", specification: "", unitCode: "EA", changeField: "quantity", changeValue: "",
});
export const stageTypes = ["RECEIVE", "CHECK", "CONFIRM", "START", "HOLD", "RESUME", "COMPLETE", "CANCEL"];
export function buildLifecyclePayload(form, revision, requestId) {
  const { eventType, responsibleUserKey, occurredAt, content, contactTarget, contactChannel } = form;
  const result = { eventType, responsibleUserKey, occurredAt, content, contactTarget, contactChannel, expectedRevision: revision, requestId };
  if (form.orderLineId && !stageTypes.includes(eventType) && !["ADD", "APPROVE", "REJECT"].includes(eventType)) result.orderLineId = Number(form.orderLineId);
  if (eventType === "CHANGE") result.changes = { [form.changeField]: form.changeValue };
  if (eventType === "POSTPONE") result.changes = { requestedDueDate: form.requestedDueDate };
  if (eventType === "FOLLOW_UP") result.nextCheckDate = form.nextCheckDate;
  if (["APPROVE", "REJECT"].includes(eventType)) result.changeRequestId = Number(form.changeRequestId);
  if (eventType === "RESUME") result.resumeStatus = form.resumeStatus;
  if (eventType === "ADD") result.item = Object.fromEntries(["itemCode", "itemName", "specification", "quantity", "unitCode", "requestedDueDate"].map((key) => [key, form[key]]));
  return result;
}
export function validateLifecycleForm(form) {
  if (!form.responsibleUserKey.trim()) return "담당자를 입력해 주세요.";
  if (!form.occurredAt) return "조치 일시를 입력해 주세요.";
  if (!form.content.trim()) return "기록 내용을 입력해 주세요.";
  if (["CHANGE", "POSTPONE", "FOLLOW_UP", "ACTION_DONE"].includes(form.eventType) && !form.orderLineId) return "처리할 품목을 선택해 주세요.";
  if (form.eventType === "FOLLOW_UP" && !form.nextCheckDate) return "다음 확인일을 입력해 주세요.";
  if (form.eventType === "POSTPONE" && !form.requestedDueDate) return "변경 납기를 입력해 주세요.";
  if (form.eventType === "CHANGE" && form.changeField !== "specification" && !form.changeValue.trim()) return "변경 값을 입력해 주세요.";
  if (["APPROVE", "REJECT"].includes(form.eventType) && !form.changeRequestId) return "변경 요청을 선택해 주세요.";
  if (form.eventType === "RESUME" && !form.resumeStatus) return "재개 단계를 선택해 주세요.";
  if (form.eventType === "ADD" && ["itemCode", "itemName", "quantity", "unitCode", "requestedDueDate"].some((key) => !form[key].trim())) return "추가 품목의 필수 정보를 입력해 주세요.";
  return "";
}
